import React, { Component } from 'react';
import SearchBox from './searchBox';
import { inject, observer } from 'mobx-react';

@inject('translationsStore') @observer
export default class SearchBoxContainer extends Component {

    constructor(props) {
        super(props);

        this.state = {
            keywords : {
                searchLibrary: this.props.translationsStore.translate('SEARCH'),
                clear: this.props.translationsStore.translate('CLEAR')
            }
        };
    }

    render() {
        return (
            <SearchBox {...this.props} keywords={this.state.keywords} />
        );
    }
}